/* eslint-disable */

/** The reason or regulation associated with the deletion request */
export enum Reason {
  /**
   * NOT_AVAILABLE - This reason should only be used for state transitions where the
   * original provided reason is not available.
   */
  NOT_AVAILABLE = "NOT_AVAILABLE",
  /**
   * NONE_GIVEN - To support Apple privacy requirements, deletion may not be tied to any
   * regulation.
   */
  NONE_GIVEN = "NONE_GIVEN",
  /** GDPR - EU Legislation */
  GDPR = "GDPR",
  /** CCPA - USA/California Legislation (includes CPRA) */
  CCPA = "CCPA",
  /** COPPA - USA Child Protection */
  COPPA = "COPPA",
}
